import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Radio from '@mui/material/Radio';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useAtom } from 'jotai';
import type { ControllerRenderProps } from 'react-hook-form';

import { TICKET_THREAT_RESOLUTIONS } from '@/pages/Ticket/Ticket.constants';
import type { TicketStatusDialog } from '@/pages/Ticket/Ticket.types';
import { userAtom } from '@/store/user.store';

import { INTERNAL_ONLY_RESOLUTION_IDS } from '../TicketStatusDialogThreat/TicketStatusDialogThreat.constants';

const TicketStatusCloseResolutions = ({
  field,
  hasError
}: {
  field: ControllerRenderProps<TicketStatusDialog, 'resolution'>;
  hasError: boolean;
}) => {
  const [userData] = useAtom(userAtom);
  const theme = useTheme();

  return (
    <>
      {TICKET_THREAT_RESOLUTIONS.map((resolution) => {
        return (
          (userData?.internal ||
            !INTERNAL_ONLY_RESOLUTION_IDS.includes(resolution.id)) && (
            <FormControlLabel
              key={resolution.id}
              value={resolution.id.toString()}
              checked={field?.value === resolution.id.toString()}
              control={
                <Radio
                  sx={{
                    color: hasError ? theme.vars.palette.error.main : 'inherit',
                    marginTop: theme.spacing(-0.2)
                  }}
                />
              }
              sx={{ alignItems: 'flex-start', py: 0.75 }}
              label={
                <>
                  <Typography sx={{ fontWeight: 'bold' }}>
                    {resolution.text}
                  </Typography>
                  <FormHelperText sx={{ mt: -0.05 }}>
                    {resolution.sub_text}
                  </FormHelperText>
                </>
              }
            />
          )
        );
      })}
    </>
  );
};
export default TicketStatusCloseResolutions;
